import { Download } from "lucide-react";

type AppStoreButtonProps = {
  children: string;
  href?: string;
  variant?: "primary" | "dark";
  className?: string;
  onClick?: () => void;
};

export function AppStoreButton({ children, href, variant = "primary", className = "", onClick }: AppStoreButtonProps) {
  const base =
    "inline-flex min-h-12 items-center justify-center gap-2 rounded-[14px] px-6 py-3 text-sm font-semibold transition duration-200";
  const styles =
    variant === "dark"
      ? "bg-white text-deep-1 hover:bg-ice-1"
      : "bg-text-primary text-white shadow-soft hover:bg-camera-3";
  const disabled = "cursor-default opacity-95";

  if (!href) {
    return (
      <button className={`${base} ${styles} ${disabled} ${className}`} onClick={onClick} type="button">
        <Download aria-hidden="true" size={17} />
        {children}
      </button>
    );
  }

  return (
    <a className={`${base} ${styles} ${className}`} href={href} onClick={onClick} rel="noreferrer" target="_blank">
      <Download aria-hidden="true" size={17} />
      {children}
    </a>
  );
}
